const SIDEBAR_TABS = [
  "narrate",
  "subtasks",
  "task",
  "details",
  "history",
] as const;

export type SidebarTab = (typeof SIDEBAR_TABS)[number];

// Old bookmarks (transcript/llm/script — LLM drafting retired 2026-07-14) and
// unknown values name no tab, and a nameless tab is the TASK tab — the
// mandatory first stop since the jinga/Jenga incident: no subtask work until
// the episode's task and scene are defined.
export const DEFAULT_TAB: SidebarTab = "task";

export const parseTab = (raw: unknown): SidebarTab | undefined =>
  SIDEBAR_TABS.includes(raw as SidebarTab) ? (raw as SidebarTab) : undefined;

/** Which revision the editor is showing: a saved revision's id, or the local
 * draft. Absent means "not chosen yet" — the page picks the draft, else the
 * newest revision. This stays in the route-owned URL contract so parsing a
 * bookmark never eagerly loads the annotation workbench. */
export const parseRev = (raw: unknown): number | "draft" | undefined => {
  if (raw === "draft") return "draft";
  const number =
    typeof raw === "number"
      ? raw
      : typeof raw === "string"
        ? Number(raw)
        : Number.NaN;
  return Number.isFinite(number) ? number : undefined;
};

/** The workbench's URL state. Both members are optional because a bare
 * `/label/annotate/<id>` is the normal way in — every link in the product uses
 * it, and the page supplies its own starting point. */
export interface AnnotateSearch {
  readonly tab?: SidebarTab;
  readonly rev?: number | "draft";
  readonly requirementId?: string;
  readonly legacy?: boolean;
}
